import TableBottomBar from "./TableBottomBar";

export default TableBottomBar;
